<template>
  <v-dialog v-model="surveyDialog" width="600" @click:outside="closeDialog">
    <v-card v-if="survey">
      <div class="header primary white--text px-3">
        <div class="d-flex justify-space-between align-center">
          <v-card-title class="pb-0"
            >{{ survey.type | capitalize }}: {{ survey.name }}</v-card-title
          >
          <v-btn icon @click="closeDialog">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-card-text v-if="surveyData">
        <div class="d-flex flex-row mt-4">
          <div class="ml-4">
            <span class="title">Participants: {{ totalUsers }}</span>
            <br />
          </div>
          <v-spacer></v-spacer>
          <SurveyResponsesDialog :surveyId="surveyId" />
        </div>

        <div class="pa-1 overflow-y-auto" style="max-height: 50vh">
          <v-card
            max-height="50vh"
            class="my-2"
            v-for="(question, index) in surveyData"
            :key="index"
          >
            <v-card-title class="pb-0">{{ index + 1 }}.- {{ question.question }}</v-card-title>
            <v-card-text>
              <div class="vue-survey">
                <div class="ans-cnt">
                  <div
                    v-for="(option, optionKey) in question.options"
                    :class="{ ans: true }"
                    :key="optionKey"
                  >
                    <div
                      :class="{
                        'ans-voted': true,
                        final: true,
                        selected: question.votes[optionKey] > 0,
                      }"
                    >
                      <span class="percent" v-text="question.votes[optionKey]"></span>
                      <span class="txt" v-html="option"></span>
                    </div>
                    <span
                      :class="{
                        bg: true,
                        selected: question.votes[optionKey] == question.maxVotes,
                      }"
                      :style="{
                        width: question.percentages[optionKey] + '%',
                      }"
                    ></span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SurveyResponsesDialog from "./SurveyResponsesDialog";

export default {
  props: ["surveyId"],
  components: {
    SurveyResponsesDialog,
  },
  data: () => ({
    surveyDialog: false,
    responses: null,
    maxVotes: 1,
  }),
  computed: {
    survey() {
      if (this.$props.surveyId) {
        return this.$store.state.trip.surveys[this.$props.surveyId];
      }
      return null;
    },
    totalUsers() {
      return Object.keys(this.survey.responses).length;
    },
    surveyData() {
      const { survey } = this;
      if (!survey) return null;

      const questions = survey.questions.map((a) => ({
        options: a.options,
        question: a.question,
        votes: Array(a.options.length).fill(0),
      }));

      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const userId in survey.responses) {
        const userAnswers = survey.responses[userId];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const j in survey.questions) {
          questions[j].votes[userAnswers[j]] += 1;
        }
      }

      const totalResponses = Object.keys(survey.responses).length;
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const i in survey.questions) {
        questions[i].maxVotes = Math.max(...questions[i].votes);
        questions[i].percentages = questions[i].votes.map((v) => (v / totalResponses) * 100);
      }

      return questions;
    },
  },
  methods: {
    closeDialog() {
      this.surveyDialog = false;
      this.$emit("closed");
    },
  },
  created() {
    if (this.$props.surveyId != null) {
      this.surveyDialog = true;
      this.responses = Object.keys(this.survey.responses);
    }
  },
  watch: {
    surveyId(surveyId, oldsurveyId) {
      if (surveyId && surveyId !== oldsurveyId) {
        this.surveyDialog = true;
        this.responses = Object.keys(this.survey.responses);
      }
    },
    surveyDialog(open) {
      if (!open) {
        this.$emit("closed");
      }
    },
  },
  filters: {
    capitalize: (value) => {
      if (!value) return "";
      const val = value.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    },
  },
};
</script>

<style  scoped>
.vue-survey {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.vue-survey .ans-cnt {
  margin: 20px 0;
}

.vue-survey .ans-cnt .ans {
  position: relative;
  margin-top: 8px;
  padding: 4px 0;
}

.vue-survey .ans-cnt .ans:first-child {
  margin-top: 0;
}

.vue-survey .ans-cnt .ans-voted {
  padding: 5px 0;
}

.vue-survey .ans-cnt .ans-voted .percent,
.vue-survey .ans-cnt .ans-voted .txt {
  position: relative;
  z-index: 1;
}

.vue-survey .ans-cnt .ans-voted .percent {
  font-weight: bold;
  min-width: 51px;
  display: inline-block;
  margin: 0 10px;
}

.vue-survey .ans-cnt .ans-voted.selected {
  color: white;
}

.vue-survey .ans-cnt .ans .bg {
  position: absolute;
  width: 0%;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #e1e8ed;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -webkit-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
  -moz-transition: all 0.3s cubic-bezier(0.5, 1.2, 0.5, 1.2);
}

.vue-survey .ans-cnt .ans .bg.selected {
  background-color: var(--v-primary-base);
}
</style>
